import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import LayoutContext from '../../Layouts/LayoutContext';
import {hasValue} from '../../../utils/utils';

function Indentation({
    indentation,
    children,
    styleProps={}
}) {
    const layoutContext = useContext(LayoutContext);

    const indentationWidth = hasValue(indentation) ? indentation : 20;

    const IndentationBox = (
        <div style={{ paddingLeft: indentationWidth ,...styleProps }}>
            {children}
        </div>
    );

    if (layoutContext && layoutContext.labelWidth) {
        return (
            <LayoutContext.Provider value={{...layoutContext, labelWidth: (layoutContext.labelWidth - indentationWidth)}}>
                {IndentationBox}
            </LayoutContext.Provider>
        );
    } else {
        return ( IndentationBox );
    }
}

Indentation.propTypes = {
    indentation: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    children: PropTypes.node,
    styleProps: PropTypes.shape({})
}

export default Indentation;